import RenderFieldTypeIcon from '@nile/banyan/src/Pebbles/field-type-icon/index';
import {
  ALL_SHARD_MODULES,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  getTranslatedText,
  SuperPop,
  useIntl,
  DEFAULT_FIELDS_TRANSLATED_LABEL
} from '@nile/components';
import { Link, TextStyle } from '@superops/ui-design-system';
import React, { useState } from 'react';
import CustomFieldModal from './CustomFieldModal';
import DefaultFieldModal from './DefaultFieldModal';

const LinkCell = (props) => {
  const { cell } = props;
  const intl = useIntl();
  const [modalActive, setModalActive] = useState(false);
  const data = cell?.row?.original;
  const fieldType = data?.fieldType;
  const fieldCategory = data?.fieldCategory;
  const module = cell?.column?.columnDef?.module;
  const updateField = cell?.column?.field?.action;
  const disableEdit = cell?.column?.field?.disableEdit;
  const constraints = cell?.column?.constraints || {};
  const columnName = data?.columnName;
  const hasParent = data?.parentField;

  const getTranslatedLabel = () => {
    if (fieldCategory === 'DEFAULT') {
      const i18nKey = DEFAULT_FIELDS_TRANSLATED_LABEL?.[columnName];
      if (i18nKey) {
        return getTranslatedText(intl, i18nKey);
      }
      return data.label;
    }
    return data.label;
  };

  const label = getTranslatedLabel();

  const getSuperPopMessage = () => {
    if (module === ALL_SHARD_MODULES.ticket) {
      switch (columnName) {
        case DEFAULT_FIELDS_BY_COLUMN_NAME.RESOLUTION_CODE:
          return 'admin.mandatoryTicketFields.resolutionCode.superTip.content';
        case DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS:
          return 'admin.mandatoryTicketFields.status.superTip.content';
        case DEFAULT_FIELDS_BY_COLUMN_NAME.TICKET_TYPE:
          return 'admin.mandatoryTicketFields.ticketType.superTip.content';
        default:
          return null;
      }
    }
  };

  const message = getSuperPopMessage();

  let showDefaultFieldModal = fieldCategory === 'DEFAULT';
  if (module === ALL_SHARD_MODULES.ticket && hasParent) {
    showDefaultFieldModal = false;
  }

  return (
    <>
      <div className="Link-cell">
        {data?.status === 'ACTIVE' ? (
          <Link removeUnderline onClick={() => setModalActive(true)}>
            <RenderFieldTypeIcon
              cateogry={fieldCategory}
              columnName={columnName}
              type={fieldType}
              color="#000000"
            />
            {label}
            {message && (
              <span className="supertip-wrapper">
                <SuperPop
                  position="top-start"
                  content={getTranslatedText(intl, message)}
                  trigger="mouseenter"
                />
              </span>
            )}
          </Link>
        ) : (
          <TextStyle variation="subdued">
            <span className="fx actr g10">
              <RenderFieldTypeIcon
                cateogry={fieldCategory}
                columnName={columnName}
                type={fieldType}
                color="#000000"
              />
              {label}
            </span>
          </TextStyle>
        )}

        {showDefaultFieldModal && modalActive && (
          <>
            <DefaultFieldModal
              modalActive={modalActive}
              setModalActive={setModalActive}
              disableEdit={disableEdit}
              name={columnName}
              updateField={updateField}
              module={module}
              constraints={constraints}
            />
          </>
        )}

        {(fieldCategory === 'CUSTOM' ||
          (hasParent && !showDefaultFieldModal)) &&
          modalActive && (
            <>
              <CustomFieldModal
                modalActive={modalActive}
                setModalActive={setModalActive}
                data={data}
                module={module}
                updateField={updateField}
                disableEdit={disableEdit}
                constraints={constraints}
              />
            </>
          )}
      </div>
    </>
  );
};

export default LinkCell;
